import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangle } from 'lucide-react';
import { Mascot } from '../../assets/Mascot.js';
import { Button } from '../../primitives/Button/Button.js';
import { cn } from '../../lib/cn.js';
import styles from './EmptyState.module.css';
/**
 * The three distinct empty kinds mandated by ux.md — never a bare
 * "No items": first-use (illustration + value line + primary CTA),
 * no-results (acknowledges the active filter, "Clear filters" CTA),
 * error (human cause + retry, this is NOT a generic empty state).
 */
export function EmptyState({ kind, title, description, action, mascotAlt, className }) {
    const role = kind === 'error' ? 'alert' : undefined;
    let illustration;
    if (kind === 'error') {
        illustration = (_jsx("span", { className: styles['errorIcon'], children: _jsx(AlertTriangle, { size: 40, "aria-hidden": "true" }) }));
    }
    else if (kind === 'first-use') {
        illustration = _jsx(Mascot, { pose: "thinking", size: 120, alt: mascotAlt ?? '', muted: false });
    }
    else {
        illustration = _jsx(Mascot, { pose: "thinking", size: 80, alt: mascotAlt ?? '', muted: true });
    }
    return (_jsxs("div", { role: role, className: cn(styles['emptyState'], className), children: [illustration, _jsx("p", { className: styles['title'], children: title }), description && _jsx("p", { className: styles['description'], children: description }), action && (_jsx(Button, { variant: kind === 'error' ? 'secondary' : 'primary', onClick: action.onClick, children: action.label }))] }));
}
